import { BottomNavigation } from '../components/BottomNavigation';
import { FullScreenLoadingIndicator } from '../components/FullScreenLoadingIndicator';
import { TopBar } from '../components/TopBar';
import { TransitionViewport } from '../components/TransitionViewport';
import '@/theme/globals.css';

// const inter = Inter({
//   variable: '--font-inter',
//   subsets: ['latin'],
//   // preload: false,
// });

// export const metadata: Metadata = {
//   title: 'Patchooli',
//   description: 'Patchooli is an app for tracking your mood and your mood history.',
//   other: {
//     'commit-hash': process.env.NEXT_PUBLIC_COMMIT_HASH ?? 'unknown',
//     'app-version': process.env.NEXT_PUBLIC_COMMIT_VERSION ?? 'unknown',
//   },
// };

// export const viewport: Viewport = {
//   themeColor: [
//     { media: '(prefers-color-scheme: light)', color: '#c6dee4' },
//     { media: '(prefers-color-scheme: dark)', color: '#c6dee4' },
//   ],
// };

export const Layout = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      <TransitionViewport className="relative flex shrink grow flex-col overflow-y-auto">
        <TopBar className="w-full shrink-0" />
        {/* The Routes component is the root of the app. It is used to navigate between pages. */}
        {children}
      </TransitionViewport>
      <BottomNavigation className="w-screen shrink-0" />
      <FullScreenLoadingIndicator />
    </>
  );
};
